<template>
    <div class="row">
        <div class="col-12">
            <span
                class="title text-uppercase"
                :class="{ 'mb-0' : !hasMargin }"
            >{{ text }}</span>
            <img class="pb-1 add" src="@/assets/svg/plus008CDD.svg" v-if="showAdd" @click="add()" :title="$t('general.add')" />
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    text: {
      type: String,
      required: false
    },
    showAdd: {
      default: false,
      type: Boolean,
      required: false
    },
    addLink: {
      default: '/',
      type: String,
      required: false
    },
    hasMargin: {
      default: false,
      type: Boolean,
      required: false
    }
  },
  methods: {
    add: function () {
      this.$router.push({ path: this.addLink })
    }
  }
}
</script>

<style>
    .add {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/core/Header.vue